import PropTypes from 'prop-types';
import React from 'react';
import chroma from 'chroma-js';

import Styles from './styles';

const RangeSteps = ({ height, colorRange, stepped }) => {
  let colorScale = '';
  if (stepped) {
    colorScale = chroma
      .scale(colorRange)
      .domain([0, 100])
      .classes(12);
  } else {
    colorScale = chroma.scale(colorRange).domain([0, 100]);
  }
  const rangeSteps = [];
  for (let index = 0; index < 100; index += 1) {
    rangeSteps.push(
      <Styles.GradStep
        key={`${colorScale(index)}-${index}`}
        className="d-inline-block"
        color={colorScale(index)}
        height={height}
      />
    );
  }
  return rangeSteps;
};
RangeSteps.defaultProps = {
  height: '20px',
  colorRange: 'RdYlBu',
  stepped: false
};
RangeSteps.propTypes = {
  height: PropTypes.string,
  colorRange: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  stepped: PropTypes.bool
};

const ColorRange = props => (
  <Styles.ColorRange className="w-100 p-0 d-inline-block">
    <RangeSteps {...props} />
  </Styles.ColorRange>
);

export default ColorRange;
